const componentModules = [
  ['quick-add-component', '@theme/quick-add'],
  ['cart-discount-component', '@theme/cart-discount'],
  ['variant-picker', '@theme/variant-picker'],
  ['product-card, product-card-link, swatches-variant-picker-component', '@theme/product-card'],
  ['product-form-component, add-to-cart-component', '@theme/product-form'],
  ['product-form-component, fly-to-cart', '@theme/fly-to-cart'],
  ['accordion-custom', '@theme/accordion-custom'],
  ['deferred-media, product-model', '@theme/media'],
  ['product-price', '@theme/product-price'],
  ['product-sku-component', '@theme/product-sku'],
  ['product-title', '@theme/product-title'],
  ['product-inventory', '@theme/product-inventory'],
  ['show-more-component', '@theme/show-more'],
  ['slideshow-component', '@theme/slideshow'],
  ['layered-slideshow-component', '@theme/layered-slideshow'],
  ['anchored-popover-component', '@theme/anchored-popover'],
  ['floating-panel-component', '@theme/floating-panel'],
  ['video-background-component', '@theme/video-background'],
  ['quantity-selector-component', '@theme/component-quantity-selector'],
  ['media-gallery', '@theme/media-gallery'],
  ['rte-formatter', '@theme/rte-formatter'],
  ['volume-pricing', '@theme/volume-pricing'],
  ['price-per-item', '@theme/price-per-item'],
  ['volume-pricing-info', '@theme/volume-pricing-info'],
  [
    'localization-form-component, dropdown-localization-component, drawer-localization-component',
    '@theme/localization',
  ],
  ['sticky-add-to-cart', '@theme/sticky-add-to-cart'],
];

const loadedModules = new Set();
let observer;

function containsComponent(root, selector) {
  if (root instanceof Element && root.matches(selector)) return true;
  return typeof root.querySelector === 'function' && root.querySelector(selector) !== null;
}

function loadMatchingComponents(root) {
  for (let index = componentModules.length - 1; index >= 0; index -= 1) {
    const [selector, specifier] = componentModules[index];

    if (!containsComponent(root, selector)) continue;

    componentModules.splice(index, 1);

    if (loadedModules.has(specifier)) continue;

    loadedModules.add(specifier);
    import(specifier).catch((error) => {
      console.error(`[Theme] Unable to load ${specifier}`, error);
    });
  }

  if (componentModules.length === 0) observer?.disconnect();
}

loadMatchingComponents(document);

if (componentModules.length > 0) {
  observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) loadMatchingComponents(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}
